<template>
  <div class="page-box">
    <Header />
    <!-- Banner 区 -->
    <div class="top-box">
      <div class="content-positioning">
        <div class="title-1">智慧安防解决方案</div>
        <div class="title-2">AI 巡逻机器人 + 安防系统，筑牢园区安全防线</div>
        <div class="btn-group">
          <div class="btn-primary">预约演示</div>
          <div class="btn-secondary">立即咨询</div>
        </div>
      </div>
    </div>

    <!-- 行业痛点 -->
    <div class="pain-section">
      <div class="section-title">安防行业面临的挑战</div>
      <div class="pain-grid">
        <div class="pain-item" v-for="(item, index) in painList" :key="index">
          <div class="pain-icon-wrap">{{ index + 1 }}</div>
          <div class="pain-name">{{ item.name }}</div>
          <div class="pain-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>

    <!-- 解决方案 -->
    <div class="solution-section">
      <div class="section-title light">智慧安防整体方案</div>
      <div class="solution-desc light">展示智慧安防方案架构图：前端机器人 + 中台安防管理 + 后台数据分析</div>
      <div class="solution-placeholder">
        <div class="placeholder-text">解决方案架构图区域</div>
      </div>
    </div>

    <!-- 核心模块 -->
    <div class="feature-section">
      <div class="section-title">核心模块</div>
      <div class="feature-grid">
        <div class="feature-item" v-for="(item, index) in featureList" :key="index">
          <div class="feature-icon-wrap">{{ index + 1 }}</div>
          <div class="feature-name">{{ item.name }}</div>
          <div class="feature-list">
            <div class="feature-list-item" v-for="(sub, idx) in item.features" :key="idx">
              <span class="check-icon">✓</span>
              <span>{{ sub }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 方案优势 -->
    <div class="advantage-section">
      <div class="section-title">方案核心优势</div>
      <div class="advantage-grid">
        <div class="advantage-card" v-for="(item, index) in advantageList" :key="index">
          <div class="advantage-num">{{ index + 1 }}</div>
          <div class="advantage-content">
            <div class="advantage-name">{{ item.name }}</div>
            <div class="advantage-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 适用场景 -->
    <div class="scene-section">
      <div class="section-title">适用场景</div>
      <div class="scene-table">
        <div class="table-header">
          <div class="th">场景</div>
          <div class="th">说明</div>
          <div class="th">推荐配置</div>
        </div>
        <div class="table-row" v-for="(item, index) in sceneList" :key="index">
          <div class="td name">{{ item.name }}</div>
          <div class="td">{{ item.desc }}</div>
          <div class="td config">{{ item.config }}</div>
        </div>
      </div>
    </div>

    <!-- 客户案例 -->
    <div class="case-section">
      <div class="section-title">客户案例</div>
      <div class="case-carousel">
        <div class="case-item" v-for="(item, index) in caseList" :key="index">
          <div class="case-placeholder">
            <div class="placeholder-text">案例图片</div>
          </div>
          <div class="case-info">
            <div class="case-name">{{ item.name }}</div>
            <div class="case-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 CTA -->
    <div class="cta-section">
      <div class="cta-title">守护安全，从智能开始</div>
      <div class="cta-desc">立即预约演示，体验智慧安防解决方案带来的安全保障</div>
      <div class="btn-group">
        <div class="btn-primary">预约演示</div>
        <div class="btn-secondary">立即咨询</div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      painList: [
        { name: '人力成本高', desc: '安保人力成本高，招聘难' },
        { name: '夜间隐患大', desc: '夜间巡逻安全隐患大' },
        { name: '监控盲区多', desc: '监控盲区多，覆盖不全' },
        { name: '异常发现慢', desc: '异常情况发现不及时' },
        { name: '响应速度慢', desc: '突发事件响应慢' },
        { name: '数据管理难', desc: '安防数据割裂，难管理' }
      ],
      featureList: [
        {
          name: '智能巡逻',
          features: ['LM203机器人7×24h自主巡逻', '预设路线巡逻', '异常自动检测', '巡逻记录追溯']
        },
        {
          name: '烟火检测',
          features: ['烟火自动识别', '烟雾浓度检测', '快速报警', '位置定位']
        },
        {
          name: '气体检测',
          features: ['有害气体检测', '气体浓度监测', '超标报警', '数据记录']
        },
        {
          name: '人员管理',
          features: ['人脸识别', '黑名单预警', '访客管理', '人员轨迹追踪']
        },
        {
          name: '监控中心',
          features: ['实时视频监控', '多画面显示', '录像存储', '远程查看']
        },
        {
          name: '报警管理',
          features: ['多渠道报警', '报警联动', '处警流程', '报警记录']
        }
      ],
      advantageList: [
        { name: '降本', desc: '安保人力成本降低60%+' },
        { name: '增效', desc: '巡逻效率提升5倍+' },
        { name: '全覆盖', desc: '机器人+固定监控，无死角' },
        { name: '快响应', desc: '异常秒级发现，快速响应' },
        { name: '可追溯', desc: '全流程数据记录，可追溯' }
      ],
      sceneList: [
        { name: '工业园区', desc: '厂区巡逻、安全监测', config: 'LM203+安防系统' },
        { name: '智慧社区', desc: '小区巡逻、安防监控', config: 'LM203+社区安防' },
        { name: '商业园区', desc: '商业区巡逻、秩序维护', config: 'LM203+商业安防' },
        { name: '物流园区', desc: '仓库巡逻、货物安全', config: 'LM203+仓储安防' },
        { name: '政府机关', desc: '大院巡逻、安全保卫', config: 'LM203+政府安防' },
        { name: '学校医院', desc: '校园/医院巡逻', config: 'LM203+校园/医院安防' }
      ],
      caseList: [
        { name: '某大型工业园区', desc: '引入智慧安防方案后，安全事故下降90%，安保成本降低60%' },
        { name: '某知名智慧社区', desc: '实现24小时智能巡逻，居民满意度提升80%' },
        { name: '某物流园区', desc: '货物安全率提升99%，异常响应时间缩短95%' }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.page-box {
  background-color: #fff;
}

/* Banner 区域 */
.top-box {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  background: linear-gradient(135deg, #6366F1 0%, #4F46E5 100%);
  display: flex;
  justify-content: center;
  padding-top: 60px;
}

.content-positioning {
  width: 1200px;
  text-align: left;
  padding-top: 120px;
}

.title-1 {
  font-weight: bold;
  font-size: 48px;
  color: #FFFFFF;
  line-height: 60px;
  margin-bottom: 20px;
}

.title-2 {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 36px;
  margin-bottom: 40px;
}

.btn-group {
  display: flex;
  gap: 20px;
}

.btn-primary {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  color: #6366F1;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: #EEF2FF;
    transform: translateY(-2px);
  }
}

.btn-secondary {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 50px;
  background: transparent;
  border: 2px solid #FFFFFF;
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

/* 通用区块样式 */
.section-title {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  line-height: 40px;
  text-align: center;
  margin-bottom: 40px;

  &.light {
    color: #FFFFFF;
  }
}

/* 行业痛点 */
.pain-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #F4F5FB;
}

.pain-grid {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}

.pain-item {
  width: 380px;
  height: 160px;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: all 0.3s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }
}

.pain-icon-wrap {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #6366F1 0%, #4F46E5 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  margin-bottom: 15px;
}

.pain-name {
  font-weight: bold;
  font-size: 18px;
  color: #222222;
  line-height: 24px;
  margin-bottom: 10px;
}

.pain-desc {
  font-size: 14px;
  color: #666666;
  line-height: 22px;
}

/* 解决方案 */
.solution-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #6366F1;
}

.solution-desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 26px;
  text-align: center;
  margin-bottom: 40px;

  &.light {
    color: rgba(255, 255, 255, 0.8);
  }
}

.solution-placeholder {
  width: 1200px;
  height: 400px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder-text {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.6);
}

/* 核心模块 */
.feature-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #FFFFFF;
}

.feature-grid {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}

.feature-item {
  width: 370px;
  background: #EEF2FF;
  border-radius: 12px;
  padding: 30px;
  box-sizing: border-box;
}

.feature-icon-wrap {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #6366F1 0%, #4F46E5 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 24px;
  color: #FFFFFF;
  margin-bottom: 20px;
}

.feature-name {
  font-weight: bold;
  font-size: 18px;
  color: #222222;
  line-height: 24px;
  margin-bottom: 15px;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feature-list-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #666666;
  line-height: 18px;
}

.check-icon {
  color: #6366F1;
  margin-right: 8px;
  font-weight: bold;
}

/* 方案优势 */
.advantage-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #F4F5FB;
}

.advantage-grid {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.advantage-card {
  width: 230px;
  background: #FFFFFF;
  border-radius: 12px;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.advantage-num {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #6366F1 0%, #4F46E5 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  margin-bottom: 15px;
}

.advantage-name {
  font-weight: bold;
  font-size: 16px;
  color: #222222;
  margin-bottom: 8px;
}

.advantage-desc {
  font-size: 13px;
  color: #666666;
  line-height: 20px;
}

/* 适用场景 */
.scene-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #FFFFFF;
}

.scene-table {
  width: 1200px;
  margin: 0 auto;
  background: #FFFFFF;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #E5E7EB;
}

.table-header {
  display: flex;
  background: #F9FAFB;

  .th {
    padding: 20px;
    font-weight: bold;
    font-size: 16px;
    color: #222222;
    text-align: left;

    &:first-child {
      width: 150px;
    }

    &:last-child {
      flex: 1;
    }
  }
}

.table-row {
  display: flex;
  border-top: 1px solid #E5E7EB;

  .td {
    padding: 20px;
    font-size: 14px;
    color: #666666;
    line-height: 22px;
    text-align: left;

    &:first-child {
      width: 150px;
    }

    &.name {
      font-weight: 500;
      color: #222222;
    }

    &.config {
      flex: 1;
    }
  }
}

/* 客户案例 */
.case-section {
  width: 100%;
  min-width: 1200px;
  padding: 80px 0;
  background: #F4F5FB;
}

.case-carousel {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 30px;
}

.case-item {
  flex: 1;
}

.case-placeholder {
  width: 100%;
  height: 200px;
  background: #E0E0E0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.case-info {
  padding: 20px;
  background: #FFFFFF;
  border-radius: 0 0 12px 12px;
}

.case-name {
  font-weight: bold;
  font-size: 18px;
  color: #222222;
  margin-bottom: 10px;
}

.case-desc {
  font-size: 14px;
  color: #666666;
  line-height: 22px;
}

/* CTA 区域 */
.cta-section {
  width: 100%;
  min-width: 1200px;
  padding: 100px 0;
  background: #FFFFFF;
  text-align: center;
}

.cta-title {
  font-weight: bold;
  font-size: 36px;
  color: #222222;
  margin-bottom: 20px;
}

.cta-desc {
  font-size: 18px;
  color: #666666;
  margin-bottom: 40px;
}
</style>
